import React from 'react';
import { A11Y_INLINE_MIN_SIZE } from "../../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";

var CheckboxSvg = function CheckboxSvg() {
  return ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: A11Y_INLINE_MIN_SIZE,
    focusable: "false",
    "aria-hidden": true
  }, ___EmotionJSX("path", {
    className: "tick",
    d: "M8 12l3 3 5-6",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeDashoffset: "0"
  }));
};

export default CheckboxSvg;